import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import MainHome from './pages/MainHome';
import Learners from './pages/Learners';
import Creator from './pages/Creator';
import EarlySubscriberForm from './pages/EarlySubscriberForm';
import AutomatedWorkflows from './pages/AutomatedWorkflows';
import CommunicationTools from './pages/CommunicationTools';
import PaymentTracking from './pages/PaymentTracking';


function App() {
  return (
    <AuthProvider>
      <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<MainHome />} />
              <Route path="/creator" element={<Creator />} />
              <Route path="/learn" element={<Learners />} />
              <Route path="/features/automated-workflows" element={<AutomatedWorkflows />} />
              <Route path="/features/communication-tools" element={<CommunicationTools />} />
              <Route path="/features/payment-tracking" element={<PaymentTracking />} />
              <Route path="/early-access" element={<EarlySubscriberForm />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 